<div class="wrapper menu-widget" role="banner">
  <div id="header-full">
    <div class="container headerContainer blueBarContainer">
      <div class="row">
        <div class="col-xs-12">
          <a href="/credit-cards/citi-costco-credit-card-conversion" tabindex="0" role="link" title="Citibank & Costco Wholesale logo">
            <img src={{imagePrefix}}{{logoImage}} class="headerLogos withBurger" alt="Citi | Costco Wholesale"
              role="presentation" />
          </a>
          <div id="wrap-burger" [@toggleMenuButton]="animationToggleMenu"
            style="display: block; right: 0px; background-position: 139.75% center;">
            <button class="menu-button" role="button" (click)="toggleMenu = !toggleMenu;showSideNavigation();"
              id="menuButton-280" aria-controls="navList" aria-haspopup="true"
              [attr.aria-expanded]="toggleMenu"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="navigation" class="inlineNavContainer" style="position: relative;" [@menuItems]="animationToggleMenu">
    <nav class="container headerContainer text-left" role="navigation">
      <ul id="navList" class="menu-bar inlineNavigation list-inline col-md-10"  role="menu">
        <ng-container *ngFor="let header of headerLinks; let i = index">
          <li class="animateToDiveLink" id="{{header.id}}" role="none">
            <a href="javascript:void(0)" role="menuitem" [ngClass]="{'active-menu': i === selectedMenu}" tabindex="0"
              [title]="header.text" (click)="scrollToElement(header.element, i)"
              (keypress)="scrollToElement(header.element, i)">{{header.text}}</a>
          </li>
        </ng-container>
        <li role="none" class="footer-link" *ngFor="let footer of footerLinks; let i = index">
          <a role="menuitem" href={{footer.linkURL}} target="_blank" rel="noopener" [innerHTML]="footer.text"></a>
        </li>
      </ul>
    </nav>
  </div>
</div>
